"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _createMixin = _interopRequireDefault(require("../utils/createMixin"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = (0, _createMixin["default"])(function (theme) {
  var elevation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var boxShadow = "".concat(theme.elevation.size, "px ").concat(theme.elevation.spread, "px ").concat(theme.elevation.offset, "px ").concat(theme.elevation.color);
  return (0, _styledComponents.css)(["box-shadow:", ";"], elevation ? boxShadow : 'none');
});
exports["default"] = _default;